import { Box, Stack, styled, Typography } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

export const TimeKeepingWrapper = styled(Stack)(({ theme }) => ({
  flexDirection: "column",
  gap: pxToRem(20),
  margin: `${pxToRem(24)} ${pxToRem(20)}`,
}));

export const Header = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  [theme.breakpoints.down("md")]: {
    gap: pxToRem(24),
    justifyContent: "center",
  },
}));

export const TextCenter = styled(Typography)(({ theme }) => ({
  fontSize: pxToRem(12),
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  width: "100%",
}));

export const BoxCol = styled(Box)(({ theme }) => ({
  background: "white",
  marginLeft: `-${pxToRem(15)}`,
  marginRight: `-${pxToRem(17)}`,
  width: `calc(100% + ${pxToRem(32)})`,
  height: `100%`,
  justifyContent: "center",
  padding: `${pxToRem(8)} ${pxToRem(16)}`,
}));
